import React from 'react'
import reactJs from '../assets/skills/react.svg'
import springBoot from '../assets/skills/spring.svg'
import bootstrap from '../assets/skills/bootstrap.svg'
import django from '../assets/skills/django.svg'
import express from "../assets/skills/express.svg"
import tailwind from '../assets/skills/tailwind.svg'
import js from '../assets/skills/js.svg'
import java from '../assets/skills/java.svg'
import python from '../assets/skills/python.svg'
import ts from '../assets/skills/ts.svg'
import db from '../assets/skills/mongodb.svg'
import mysql from "../assets/skills/mysql.svg"
import postgres from '../assets/skills/postgres.svg'
import { motion } from 'framer-motion'
import { fadeIn } from '../variants'

const Skills = () => {
  return (
    <section id='services' className='section'>
        
        <div className="container mx-auto lg:flex flex-col lg:items-center lg:justify-center ">
        <h2 className='text-center pt-3 mb-2 text-3xl' >Professional Skillset</h2>
            <div className='w-[65%] lg:w-[90%] m-auto lg:m-0 lg:flex  lg:flex-row gap-x-12'>
                <motion.div variants={fadeIn('right',0.4)} 
                    initial='hidden' whileInView={"show"} 
                    viewport={{once:false,amount:0.7}}  className="rounded-xl lg:w-[32%]  border-1 py-1 shadow-2xl bg-slate-400/100 flex justify-center flex-col items-center">
                    <h3 className='text-center pb-2 font-tertiary'>Languages</h3>
                    <div className="skills__dataa">
                        <i class="uil"><img className='w-16' src={js} alt="JavaScript" /></i>
                        <div>
                            <h3 className="skills__name">JavaScript</h3>
                        </div>
                    </div>
                    <div className="skills__dataa">
                        <i class="uil" ><img className='w-16' src={ts} alt="typescript" /></i>
                        <div>
                            <h3 className="skills__name">Typescript</h3>
                        </div>
                    </div>
                    <div className="skills__dataa">
                        <i class="uil"><img className='w-16' src={java} alt="Java" /></i>
                        <div>
                            <h3 className="skills__name">Java</h3>
                        </div>
                    </div>
                     <div className="skills__dataa">
                     <i class="uil"><img className='w-16' src={python} alt="Python" /></i>
                     <div>
                         <h3 className="skills__name">Python</h3>
                     </div>
                    </div>
                </motion.div>
    
            

                <motion.div variants={fadeIn('down',0.4)} 
                    initial='hidden' whileInView={"show"} 
                    viewport={{once:false,amount:0.3}}  className="rounded-xl lg:w-[32%]  border-1 my-4 py-2 shadow-2xl bg-slate-400/100 flex justify-center flex-col  items-center">
                    <h3 className='text-center pb-2 font-tertiary'>Frameworks</h3>
                    <div className="skills__dataa">
                        <i class="uil"><img className='w-16' src={reactJs} alt="react" /></i>
                        <div>
                            <h3 className="skills__name">React js</h3>
                        </div>
                    </div>
                    <div className="skills__dataa">
                     <i class="uil"><img className='w-16' src={express} alt="node" /></i>
                     <div>
                         <h3 className="skills__name">Express js</h3>
                     </div>
                    </div>
                    <div className="skills__dataa">
                        <i class="uil"><img className='w-16' src={springBoot} alt="SpringBoot" /></i>
                        <div>
                            <h3 className="skills__name">SpringBoot</h3>
                        </div>
                    </div>
                    <div className="skills__dataa">
                        <i class="uil"><img className='w-16' src={django} alt="Django" /></i>
                        <div>
                            <h3 className="skills__name">Django</h3>
                        </div>
                    </div>
                    <div className="skills__dataa">
                        <i class="uil" ><img className='w-16' src={bootstrap} alt="bootstrap" /></i>
                        <div>
                            <h3 className="skills__name">BootStrap</h3>
                        </div>
                    </div>
                    <div className="skills__dataa">
                        <i class="uil"><img className='w-16' src={tailwind} alt="tailwind" /></i>
                        <div>
                            <h3 className="skills__name">Tailwind CSS</h3>
                        </div>
                    </div>
                </motion.div>

                <motion.div variants={fadeIn('left',0.2)} 
                    initial='hidden' whileInView={"show"} 
                    viewport={{once:false,amount:0.7}}  className="rounded-xl lg:w-[32%]   border-1 py-6 shadow-2xl bg-slate-400/100 flex justify-center flex-col items-center">
                    <h3 className='text-center pb-2 font-tertiary'>Databases</h3>
                    <div className="skills__dataa">
                        <i class="uil"><img className='w-16' src={db} alt="MongoDB" /></i>
                        <div>
                            <h3 className="skills__name">MongoDB</h3>
                        </div>
                    </div>
                    <div className="skills__dataa">
                        <i class="uil" ><img className='w-16' src={mysql} alt="MySql" /></i>
                        <div>
                            <h3 className="skills__name">MySql</h3>
                        </div>
                    </div>
                    <div className="skills__dataa">
                        <i class="uil"><img className='w-16' src={postgres} alt="PostgreSQL" /></i>
                        <div>
                            <h3 className="skills__name">PostgreSQL</h3>
                        </div>
                    </div>
                </motion.div>
                
                
                
            </div>
        </div>
    </section>
  )
}

export default Skills